import axios, { AxiosRequestHeaders } from "axios";
import { revalidateAuth } from "../components/utils";
import { useAuthStore } from "../store";

const optionsApi = axios.create({
  baseURL:
    localStorage.getItem("esopNodeApi") ||
    process.env.REACT_APP_OPTIONS_API ||
    "http://localhost:4000",
});
optionsApi.defaults.headers.post["Content-Type"] = "application/json";
optionsApi.interceptors.request.use((config) => {
  const accesstoken =
    localStorage.getItem("accesstoken") || useAuthStore.getState().accessToken;
  revalidateAuth();
  if (accesstoken && !config.url?.endsWith("/login")) {
    (config.headers as AxiosRequestHeaders).companyId =
      localStorage.getItem("companyId") || "";
    (config.headers as AxiosRequestHeaders).Authorization = accesstoken;
  }
  return config;
});

export default optionsApi;
